// Organization (your brand - used everywhere)
export const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "GraceTechie",
    url: "https://gracetechie.com.ng",
    logo: "https://gracetechie.com.ng/logo.png",
  };